import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Nav from "@/components/Nav";
import { toast } from "sonner";
import { Trash } from "@phosphor-icons/react";

export default function AdminVendors() {
  const [vendors, setVendors] = useState([]);
  const [f, setF] = useState({ name:"", city:"", contact:"", specialties:"", capacity:"medium" });
  const [loading, setLoading] = useState(false);

  const load = () => api.get("/vendors").then(r => setVendors(r.data));
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/vendors", { ...f, specialties: f.specialties.split(",").map(s=>s.trim()).filter(Boolean) });
      toast.success("Vendor added");
      setF({ name:"", city:"", contact:"", specialties:"", capacity:"medium" });
      load();
    } catch { toast.error("Failed to add vendor"); }
    finally { setLoading(false); }
  };

  const remove = async (id) => {
    try { await api.delete(`/vendors/${id}`); load(); toast.success("Removed"); }
    catch { toast.error("Delete failed"); }
  };

  return (
    <div className="min-h-screen bg-[var(--pf-bg)]">
      <Nav />
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-10">
        <div className="pf-label mb-3">Admin · Vendor Network</div>
        <h1 className="text-5xl font-black tracking-tighter mb-10">Print vendors.</h1>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          <form onSubmit={submit} className="lg:col-span-4 border border-[var(--pf-border)] p-6 h-fit space-y-5" data-testid="vendor-form">
            <div className="pf-label">Add vendor</div>
            <div>
              <label className="pf-label block mb-1">Name</label>
              <input required className="pf-input" data-testid="vendor-name" value={f.name} onChange={(e)=>setF({...f,name:e.target.value})} />
            </div>
            <div>
              <label className="pf-label block mb-1">City</label>
              <input required className="pf-input" data-testid="vendor-city" value={f.city} onChange={(e)=>setF({...f,city:e.target.value})} />
            </div>
            <div>
              <label className="pf-label block mb-1">Contact</label>
              <input required className="pf-input" data-testid="vendor-contact" value={f.contact} onChange={(e)=>setF({...f,contact:e.target.value})} placeholder="phone / email" />
            </div>
            <div>
              <label className="pf-label block mb-1">Specialties (comma separated)</label>
              <input className="pf-input" data-testid="vendor-specialties" value={f.specialties} onChange={(e)=>setF({...f,specialties:e.target.value})} placeholder="business_card, brochure" />
            </div>
            <div>
              <label className="pf-label block mb-1">Capacity</label>
              <div className="flex gap-2 mt-1">
                {["small","medium","large"].map(c => (
                  <button type="button" key={c} onClick={()=>setF({...f,capacity:c})}
                    className={`flex-1 py-2 border-2 text-xs uppercase font-bold tracking-widest ${f.capacity===c?"bg-[var(--pf-text)] text-white border-[var(--pf-text)]":"border-[var(--pf-border)]"}`}>{c}</button>
                ))}
              </div>
            </div>
            <button type="submit" disabled={loading} className="pf-btn-primary w-full justify-center" data-testid="add-vendor">
              {loading ? "Adding…" : "Add vendor →"}
            </button>
          </form>

          <div className="lg:col-span-8">
            {vendors.length === 0 ? (
              <div className="border border-dashed border-[var(--pf-border)] p-16 text-center text-[var(--pf-text-2)]" data-testid="no-vendors">
                No vendors yet.
              </div>
            ) : (
              <div className="border border-[var(--pf-border)]">
                {vendors.map(v => (
                  <div key={v.id} className="grid grid-cols-12 gap-4 items-center p-5 border-b last:border-0 border-[var(--pf-border)]" data-testid={`vendor-row-${v.id}`}>
                    <div className="col-span-4">
                      <div className="font-bold">{v.name}</div>
                      <div className="text-xs text-[var(--pf-text-2)] mt-1">{v.contact}</div>
                    </div>
                    <div className="col-span-3 text-sm">{v.city}</div>
                    <div className="col-span-3 text-xs">{v.specialties?.join(", ") || "—"}</div>
                    <div className="col-span-1 pf-label">{v.capacity}</div>
                    <div className="col-span-1 text-right">
                      <button onClick={()=>remove(v.id)} className="text-[var(--pf-text-2)] hover:text-[var(--pf-brand)]" data-testid={`del-vendor-${v.id}`}><Trash size={16}/></button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
